import { AUTH_TOKEN, COOKIE_AUTH_DETAILS, ROLES } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';
import { forEach } from 'lodash';
import { parseJwt, getAuthDetails, hasRestrictedRole } from './commonUtils';
import { phoneRegExp } from './constants';
export * from './commonUtils';

const serviceProvider = window.$environment?.SERVICE_PROVIDER;
const appLayout = window.$environment.CURRENT_LAYOUT;

export const removeEmptyValues = (obj) => {
  const newObj = {};
  for (let key in obj) {
    if (obj[key] !== '' && obj[key] !== null) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};

export const hasEnterpriseFeatureEnabled = (module) => {
  const auth = getAuthDetails();
  if (auth && auth?.enterpriseFeatureDto?.[module] && auth?.enterpriseFeatureDto?.[module] === true) {
    return true;
  } else {
    return false;
  }
};

export const getGenerateModuleRelation = (menus) => {
  try {
    const enterpriseFeatureDto = getAuthDetails()?.enterpriseFeatureDto;
    const pageUrls = require(`@/routes/web/${window?.$environment?.SERVICE_PROVIDER}/privateConfig`).default;
    let newMenus = [];
    forEach(menus, (menu, id) => {
      const urlConfig = pageUrls?.find((e) => e?.url === (menu?.path || menu?.url));
      if (
        urlConfig &&
        urlConfig?.module &&
        !menu?.module &&
        enterpriseFeatureDto &&
        enterpriseFeatureDto[urlConfig?.module] !== undefined
      ) {
        newMenus.push({
          ...menu,
          module: urlConfig?.module,
        });
        return;
      } else if (
        urlConfig &&
        urlConfig?.subscriptions &&
        !menu?.module &&
        enterpriseFeatureDto &&
        enterpriseFeatureDto[urlConfig?.subscriptions] !== undefined
      ) {
        newMenus.push({
          ...menu,
          module: urlConfig?.subscriptions,
        });
        return;
      }
      newMenus.push({
        ...menu,
        ...(urlConfig?.subscriptions ? { dependency: [urlConfig?.subscriptions || '', ...(menu?.dependency || [])] } : {}),
      });
    });
    return newMenus;
  } catch (error) {}
};

export const isCRMImport = () => {
  return (
    window?.$environment?.SERVICE_PROVIDER === 'riskTheory' &&
    hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER])
  );
};

export const removeDuplicates = (arr) => {
  const seen = new Set();
  return arr.filter((obj) => {
    const stringified = JSON.stringify(obj);
    if (!seen.has(stringified)) {
      seen.add(stringified);
      return true;
    }
    return false;
  });
};

export const checkIsAdmin = () => {
  const auth = getCookie(COOKIE_AUTH_DETAILS);
  if (auth && Object.keys(auth).length) {
    let token = parseJwt(auth[AUTH_TOKEN]);
    return Boolean(token.from_admin);
  }
};

export const getUserMail = () => {
  const auth = getCookie(COOKIE_AUTH_DETAILS);
  if (auth && Object.keys(auth).length) {
    let token = parseJwt(auth[AUTH_TOKEN]);
    return token.sub || '';
  }
};

export const phoneNumberValidation = (inputVal) => {
  if (inputVal.substring(0, 12).match(phoneRegExp)) {
    return inputVal.substring(0, 12);
  } else {
    const number = /^[0-9]+$/;
    let value = inputVal.split('-').join('');
    const isValid = value.match(number);
    let updatedValue = isValid ? value.match(/.{1,3}/g).join('-') : value.split(value.length, 0);
    updatedValue = updatedValue.length === 13 ? updatedValue.slice(0, updatedValue.length - 2) : updatedValue;
    return updatedValue || '';
  }
};

export const objectIntoArray = (list = null) => {
  return list
    ? Object.entries(list)
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .map(([key, value]) => ({ value: key, label: value }))
    : [];
};

export const loadStyle = (ParentStyled, url) => {
  try {
    const style = require(`@/${url}/${window?.$environment?.CURRENT_LAYOUT}`)?.default;
    return { ...ParentStyled, ...style };
  } catch (error) {
    return ParentStyled;
  }
};

export const loadPageConfig = () => {
  try {
    return require(`@/config/pages/${serviceProvider}/${appLayout}`);
  } catch (error) {
    return require(`@/config/pages/${serviceProvider}`);
  }
};

export const isSingleRoleOnlyUser = (role = '') => {
  const auth = getAuthDetails(false);
  if (auth && auth.roles && auth.roles?.length === 1 && auth.roles.includes(role)) return true;
  return false;
};

export const isDriver = () => {
  const auth = getAuthDetails(false);
  if (auth && auth.roles && auth.roles.includes('DRIVER')) return true;
  return false;
};

export const isdvirOnlyUser = () => {
  const auth = getAuthDetails(false);
  if (auth && auth.enterpriseFeatureDto && auth.enterpriseFeatureDto?.dvirOnlyUserEnabled) return true;
  return false;
};
